// The viewer renders page 0, so page 0's calibration drives the tolerances.
export const RENDERED_PAGE_INDEX = 0;

export const MARKER_MATCH_TOLERANCE_METERS = 0.5;
export const MARKER_MATCH_TOLERANCE_PDF_POINTS_FALLBACK = 20;
export const ROUTE_ENDPOINT_TOLERANCE_METERS = 1;
export const ROUTE_ENDPOINT_TOLERANCE_PDF_POINTS_FALLBACK = 40;
export const ROUTE_METERS_CHANGED_RATIO = 0.1;
export const PAGE_FORMAT_RELATIVE_EPSILON = 0.01;
